<template>
    <div id="permissionManger">
        <el-container>
            <el-header>
                <top-Nav></top-Nav>
            </el-header>
            <el-main>
                <el-row>
                    <div style="height:56px;background:#ccc">
                        <div class="mainHead">
                            <div class="route">
                                <span class="crumbs"></span><span>权限管理</span><span></span>
                            </div>
                            <div>
                                <el-button type="primary" @click="routerList" v-if="isAuth('userMonitoring:binUserMonitor')">授权</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="permissions-content">
                        <div class="permissions-left inline" @mousemove="mousearch">
                          <!--<el-input placeholder="搜索角色名称" v-model="roleList.searname" clearable @clear="clearableBack" ref="inputRef" @blur="searchBlur()"></el-input>-->
                            <i></i>
                            <el-input v-model="leftSelect.searname" placeholder="搜索用户名称、工号" @blur="searchRole" clearable @clear="clearableBack" ref="inputRef"></el-input>
                            <div class="permissions-left_list">
                                <ul>
                                    <li v-for="(item,index) in leftData" :key="index" class="role_list" :class="{check:item.checked}" @click.stop="selectRoleList(item)">{{item.userName}}<span>|</span>{{item.userNumber}}</li>
                                </ul>
                            </div>
                        </div>
                        <div class="permissions-right inline">
                            <el-tabs v-model="activeName" type="card">
                                <el-tab-pane label="功能权限" name="first">
                                    <div class="user_name">
                                        用户角色：{{userName}}
                                    </div>
                                    <div class="table" :style="{maxHeight:treeScreenHeight+'px'}">
                                      <div v-if="isAuth('common:interface')">
                                        <el-tree
                                          :data="treeData"
                                          ref="firstTree"
                                          show-checkbox
                                          node-key="id"
                                          :default-expanded-keys="checkId"
                                          :default-checked-keys="checkId"
                                          :props="defaultProps"
                                        >
                                        </el-tree>
                                      </div>
                                    </div>
                                </el-tab-pane>
                                <el-tab-pane label="数据权限" name="second">
                                  <div class="user_name"></div>
                                  <div class="table" :style="{maxHeight:treeScreenHeight+'px'}">
                                    <el-tree
                                      :data="functionData"
                                      show-checkbox
                                      ref="thirdTree"
                                      :default-expanded-keys="treeListId"
                                      node-key="id"
                                      :props="defaultProps1"
                                    >
                                    </el-tree>
                                  </div>
                                </el-tab-pane>
                            </el-tabs>
                        </div>
                    </div>
                </el-row>
            </el-main>
        </el-container>
    </div>
</template>

<script>
import topNav from '../../components/TopNav.vue';
import {ajaxFuncJson} from "../../api/ajax";

export default {
    name: 'permissionManger',
    data() {
        return {
            activeName: 'first',
            input: '',
            checked: '',
            obj: {},
            leftSelect:{
              searname:''
            },
            leftData:[],    //左侧数据
            roleId:'',
            userName:'',
            treeData:[],
            checkId:[],
            treeListId:[],
            treeScreenHeight:'',
            dialogVisible:false,
            defaultProps: {
              children:'list',
              label:'menuName',
              disabled:'enabled'
            },
            functionData:[],
            defaultProps1:{
              children:'children',
              label:'label',
              disabled:'enabled'
            },
          selectMenuId:'',
          target:0,
          windowResize:null,
        }
    },
    created(){
      this.getAllRole();
      this.listenKeyDown();
    },
    mounted() {
      let that = this;
      that.windowResize= function () {
        that.treeScreenHeight=$('.permissions-right').height()-52-$('.user_name').height();
      };
      that.windowResize();
      window.addEventListener('resize',that.windowResize);
    },
    methods: {
        routerList(){
          this.$router.push({path:'/permissions',query:{id:this.roleId}});
        },
        searchRole(){
          if(this.target==1){
            this.leftSelect.searname= '';
            this.$refs.inputRef.$el.children[0].focus();
            this.target = 0
          }else {
            this.getAllRole();
          }
        },
        //搜索角色名称 - 清除回调
        clearableBack() {
          this.$refs.inputRef.$el.children[0].focus();
        },
      //监听enter键
      listenKeyDown(){
        let _this=this;
        document.onkeydown=function(event){
          var e = event || window.event || arguments.callee.caller.arguments[0];
          if(e && e.keyCode==13){//上,左
            _this.getAllRole();
          }
        };
      },
        mousearch(event){
          if(event.target.className == "el-input__icon el-icon-circle-close el-input__clear"){
            this.target = 1;
          }else{
            this.target = 0
          }
        },
        getAllRole(){
          ajaxFuncJson('/users/findUserAndNum',this.leftSelect).then(res=>{
            if(res.data.status==200){
              this.leftData=res.data.data;
              if(this.leftData.length>0){
                this.leftData.forEach((item,index)=>{
                  this.$set(item,'checked',false);
                });
                this.leftData[0].checked=true;
                this.roleId=this.leftData[0].id;
                this.getDataTree();
                this.getFunctionTree();
                if(this.leftData[0].rolename){
                  let allUserName=[];
                  this.leftData[0].rolename.forEach((list,index)=>{
                    allUserName.push(list.name);
                  });
                  this.userName=allUserName.join(';');
                }
              }else {
                this.treeData=[];
                this.userName='';
              }
            }else {
              this.$message({
                message:res.data.msg,
                type:'error',
              })
            }
          });
        },
      getSetPermissionId(){
        let params={
          userId:this.roleId,
          menuId:this.selectMenuId,
        };
        ajaxFuncJson('/userMonitoring/findUserMonitor',params).then(res=>{
          if(res.data.status==200){
            this.dialogVisible=true;
            this.treeListId=[];
            if(res.data.data.length>0){
              res.data.data.forEach((idList,index)=>{
                this.treeListId.push(idList.monitoringId);
              })
            }
            this.$nextTick(()=>{
              this.$refs.thirdTree.setCheckedKeys(this.treeListId);
            });
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        })
      },
      //筛选勾选的树形图
      filterNode(value, data) {
        if (!value) return true;
        return value.indexOf(data.id)!== -1;
      },
      //点击左侧用户和工号
        selectRoleList(list){
            this.leftData.forEach((item,index)=>{
              if(list.id==item.id){
                this.leftData[index].checked=true;
                this.roleId=list.id;
                this.getDataTree();
                this.getFunctionTree();
                let allUserName=[];
                item.rolename.forEach((list,index)=>{
                  allUserName.push(list.name);
                });
                this.userName=allUserName.join(';');
              }else {
                this.leftData[index].checked=false;
              }
            });
        },
      //获取权限的数据
      getDataTree(){
        let params={
          id:this.roleId,
        };
        ajaxFuncJson('/menu/tree/list',params).then(res=>{
          if(res.data.status==200){
            this.treeData=res.data.data.menuList;
            this.checkId=res.data.data.permissions;
          }else {
            this.$message({
              message:res.data.msg,
              type:'error',
            })
          }
        });
      },
      //获取数据权限的数据
      getFunctionTree(){
        let params={
          id:this.roleId,
        };
        ajaxFuncJson('/menu/getDateAuthorityTree',params).then(res=>{
          if(res.data.status==200){
            this.functionData=res.data.data;
            this.functionData.forEach((item,index)=>{
              if(item.children.length>0&&item.children){
                item.children.forEach((items,indexes)=>{
                  if(items.children.length>0&&items.children){
                    items.children.forEach((thirdItem,thirdIndex)=>{
                      if(String(thirdItem.label).indexOf('-')!=-1){
                        this.functionData[index].children[indexes].children[thirdIndex].label=String(thirdItem.label).replace('-','B');
                      }else if(String(thirdItem.label).indexOf('待标注')!=-1){
                        this.functionData[index].children[indexes].children[thirdIndex].label=thirdItem.label;
                      }else {
                        this.functionData[index].children[indexes].children[thirdIndex].label='L'+thirdItem.label;
                      }
                    })
                  }
                })
              }
            });
            this.getSetPermissionId();
          }else {
            this.$message({
              message:res.data.msg,
              type:'error'
            })
          }
        });
      },
    },
    destroyed(){
      let _this=this;
      window.removeEventListener("resize",_this.windowResize)
    },
    components: {
        topNav,
    }
}
</script>

<style lang="scss" scope>
    #permissionManger {
        height: 100%;
        .el-container {
            height: 100%;
            .el-main {
                width: 100% !important;
                height: 100% !important;
                margin: 0 !important;
                padding: 0 20px 10px 20px;
                background: #f2f2f2;
                .el-row {
                    margin-top: 10px;
                    background: #fff;
                    height: calc(100% - 10px);;
                  .mainHead{
                    margin-right: 0;
                  }
                    .permissions-content {
                        .inline {
                            float: left;
                        }
                        margin-top: 20px;
                        height: calc(100% - 77px);
                        .permissions-left {
                            width: 394px;
                            margin-left: 40px;
                            height: calc(100% - 20px);
                          position: relative;
                          >i {
                            position: absolute;
                            top: 12px;
                            left: 10px;
                            width: 16px;
                            height: 16px;
                            background: url("../../assets/img/search2.png");
                            cursor: pointer;
                            z-index: 1;
                          }
                            .permissions-left_list {
                                height: calc(100% - 32px);
                                overflow: hidden;
                                overflow-y: auto;
                                border: 1px solid #e0e0e0;
                                border-top: none;
                              .role_list{
                                padding-left: 20px;
                                font-size: 13px;
                                color: #282828;
                                cursor: pointer;
                                span{
                                  padding: 0 10px;
                                }
                              }
                              .check{
                                color: #198cff;
                                background: #F5F5F5;
                              }
                            }
                            .permissions-left_list::-webkit-scrollbar {/*滚动条整体样式*/
                                width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
                                height: 1px;
                            }
                            .permissions-left_list::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                                border-radius: 2px;
                                -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                                background: #dddddd;
                            }
                            .permissions-left_list::-webkit-scrollbar-track {/*滚动条里面轨道*/
                                -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                                border-radius: 2px;
                                background: #f5f5f5;
                            }
                            .el-input .el-input__inner{
                              width: 100% !important;
                              padding-left: 30px!important;
                              height: 40px;
                            }
                            .permissions-left_list {
                                li {
                                    height: 35px;
                                    list-style: none;
                                    line-height: 35px;
                                    border-bottom: 1px solid #f5f5f5;
                                }
                                li:hover {
                                    background: #f5f5f5;
                                }
                            }
                        }
                        .permissions-right {
                            height: calc(100% - 20px);
                            margin-left: 40px;
                            width: calc(100% - 474px);
                            .el-tabs--card > .el-tabs__header {
                                height: 32px;
                            }
                            .el-tabs__content {
                                margin-top: 20px;
                            }
                            .el-tabs--card > .el-tabs__header .el-tabs__nav {
                                border-radius: 0;
                                z-index: 0;
                            }
                            .el-tabs--card > .el-tabs__header .el-tabs__item {
                                width: 80px;
                                height: 30px;
                                line-height: 30px;
                                margin-right: -1px;
                                font-size: 13px;
                                border: 1px solid #e0e0e0;
                            }
                            .el-tabs--card > .el-tabs__header .el-tabs__item:hover{
                              border: 1px solid #198cff;
                            }
                            .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
                                background: #198cff;
                                color: #ffffff;
                                margin-bottom: 0;
                                border: 1px solid #198cff;
                            }
                            .table {
                                padding-right: 20px;
                                padding-top: 10px;
                                overflow: auto;
                              .el-tree{
                                .el-checkbox__input{
                                  z-index: 0;
                                }
                              }
                            }
                            .table::-webkit-scrollbar {/*滚动条整体样式*/
                              width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
                              height: 1px;
                            }
                            .table::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
                              border-radius: 2px;
                              -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                              background: #dddddd;
                            }
                            .table::-webkit-scrollbar-track {/*滚动条里面轨道*/
                              -webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0.2);
                              border-radius: 2px;
                              background: #f5f5f5;
                            }
                        }
                    }
                }
            }
        }
      .tree_container1{
        padding-bottom: 20px;
        max-height: 500px;
        overflow: auto;
      }
    }
</style>



// WEBPACK FOOTER //
// src/page/systemManger/permissionManger.vue